import styled from 'styled-components'

export const Block = styled.div`
  padding: 15px;
  border: 1px solid black;
  margin-top: 20px;
  margin-bottom: 10px;
`
